import React from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash-es';
import { toSentenceCase } from 'client/utils/string-utils';
import {
  getOwnerDisplayDescription,
  getTitleDisplayDescription,
  getUsageTypeDisplayDescription,
} from 'site-modules/shared/components/usurp-inventory-card/usurp-inventory-card-helper';
import { ALLOWED_HISTORY_PROVIDERS } from 'site-modules/shared/constants/inventory/vehicle-history';

export function SrpCardVehicleHistory({ historyInfo }) {
  const { historyProvider } = historyInfo;

  if (!ALLOWED_HISTORY_PROVIDERS.includes(historyProvider)) {
    return null;
  }

  const accidentDisplay = getTitleDisplayDescription(historyInfo);
  const ownerDisplay = getOwnerDisplayDescription(historyInfo);
  const usageDisplay = toSentenceCase(getUsageTypeDisplayDescription(historyInfo));
  const historySummary = toSentenceCase(compact([accidentDisplay, ownerDisplay, usageDisplay]).join(', '));

  return (
    <>
      <dt className="small fw-bold">Vehicle History:</dt>
      <dd className="xsmall mb-1">{historySummary}</dd>
    </>
  );
}

SrpCardVehicleHistory.propTypes = {
  historyInfo: PropTypes.shape({}).isRequired,
};
